import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useAuthMe } from '../../hooks/queries';
import { isE2ETestMode } from '../../utils/e2e-test-mode';
import { hasAppAccess } from '../../utils/support-user';
import { AccessDenied } from './AccessDenied';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

function isForbiddenError(error: unknown): boolean {
  return typeof error === 'object' && error !== null && 'status' in error
    && (error as { status?: number }).status === 403;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated } = useAuth();
  const e2eTestMode = isE2ETestMode();
  const { data, isLoading, error } = useAuthMe();
  const persona = data?.data;

  if (!e2eTestMode && !isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (isLoading) {
    return (
      <div className="page-container">
        <div className="loading-state">
          <div className="spinner" />
          Loading…
        </div>
      </div>
    );
  }

  // E2E / dev:local bypasses Entra group checks server-side; the default mock
  // user has empty groups, so the persona gate must not block the app.
  if (
    !e2eTestMode
    && (isForbiddenError(error) || (persona !== undefined && !hasAppAccess(persona)))
  ) {
    return <AccessDenied />;
  }

  return <>{children}</>;
}
